import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiEndpoint } from '../4.1.common/api.endpoint';
import { ContractNetworkingScheduleSettingInput, ContractNetworkingScheduleSettingOutput } from '../4.2.contract/contract.schedule.setting/contract.networking.schedule.setting';
import { UtilCryptography } from 'src/app/5.transversal/5.2.utils/util.cryptography/util.cryptography';

@Injectable({
    providedIn: 'root'
})
export class NetworkingScheduleSetting implements ContractNetworkingScheduleSettingInput {

    constructor(
        private httpClient: HttpClient,
        private apiEndpoint: ApiEndpoint,
        private cryptography: UtilCryptography
    ){}

    networkingOutput?: ContractNetworkingScheduleSettingOutput;
    
    getScheduleSettingList(day: number, month: number, year: number, dayOfWeek: number, plan: number): void {
        var data: any = {
            day: day,
            month: month,
            year: year,
            dayOfWeek: dayOfWeek,
            plan: plan
        };
        let encryptedData = this.cryptography.encrypt(JSON.stringify(data));
        this.httpClient.post<any>(
            this.apiEndpoint.scheduleSettingList(),
            `{"data":"${encryptedData}"}`
        ).subscribe(
            response => {
                if(response.status && response.data != null){
                    this.networkingOutput.scheduleSettingListSuccessfulOutput(response.data);
                }else{
                    this.networkingOutput.scheduleSettingListFailureOutput();
                }
            },
            _ => {
                this.networkingOutput.scheduleSettingListFailureOutput();
            }
        )
    }
    
}